// extracted by mini-css-extract-plugin
export var infoSection = "_v-1";
export var infoSectionContainer = "_v-0";
export var infoSectionTitleRow = "_v-2";
export var multiLineInfo = "_v-4";
export var strong = "_v-3";